import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/ShoppingCart';
import create from './create';
import edit from './edit';
import list from './list';

const products: ResourceProps = {
  name: 'products',
  icon,
  options: { label: 'Produtos' },
  create,
  edit,
  list
};

export default products;
